import { all, put, call, takeEvery } from 'redux-saga/effects';
import { delay } from 'redux-saga';

import { PROCESSING_STATES } from '../../modules/constants';

import { sanitizeErrorMessage } from '@xanadu/ui-shared/utils/fetchService';
import { SET_PROMO_PAGE } from '../promoPage/actions';

import {
  REQUEST_NEW_TICKET_CREATION,
  setFormStatus,
  setContactForm,
  setFormError,
  setFormTicketID,
} from './actions';

import { sendNewTicketCreationRequest } from './api';


// The customContactForm can watch for different sources to update the reducer and be displayed
// Atm the PromoPage is the only entity using it, the inforamtion are coming from the dotCMS
// Every needed fild is populated with the requestPromoPage action payload
function* watchPromoPageRequest({ payload }) {
  yield put(setContactForm(payload));
}

function* watchNewTicketCreationRequest({ payload }) {
  try {
    const response = yield call(sendNewTicketCreationRequest, payload);
    if (response.errors) {
      console.error('Error creating ticket from contact form', response.errors); // eslint-disable-line no-console
      yield put(setFormError(sanitizeErrorMessage(response.errors)));
      yield put(setFormStatus({ status: PROCESSING_STATES.error }));
      yield delay(8000);
      yield put(setFormError(''));
      yield put(setFormStatus({ status: PROCESSING_STATES.initial }));
    } else {
      yield put(setFormTicketID(response.data.id));
      yield put(setFormStatus({ status: PROCESSING_STATES.success }));
    }
  } catch (e) {
    console.error('Error creating ticket from contact form', e); // eslint-disable-line no-console
    yield put(setFormError(e.message));
    yield put(setFormStatus({ status: PROCESSING_STATES.error }));
    yield delay(8000);
    yield put(setFormError(''));
    yield put(setFormStatus({ status: PROCESSING_STATES.initial }));
  }
}

export default function* root() {
  yield all([
    takeEvery(SET_PROMO_PAGE, watchPromoPageRequest),
    takeEvery(REQUEST_NEW_TICKET_CREATION, watchNewTicketCreationRequest),
  ]);
}
